import React from "react";
import styles from "../Privacy/Privacy.module.css";

const Terms = () => {
  return (
    <div className={styles.legalPage}>
      <div className={styles.contentWrapper}>
        <h1 className={styles.pageTitle}>Terms & Conditions</h1>
        <p className={styles.lastUpdated}>Last updated: August 2026</p>
        
        <div className={styles.legalContent}>
          <p>
            Welcome to the Sanskriti Shubh Aangan portal. By accessing and using this platform, you accept and agree to be bound by the terms and provision of this agreement. In addition, when using this portal's particular services, you shall be subject to any posted guidelines or rules applicable to such services.
          </p>

          <h2>1. Membership & Registration</h2>
          <p>
            To access certain features of the platform, you must register for an account. You agree to provide true, accurate, current, and complete information about yourself as prompted by the registration form. You are responsible for maintaining the confidentiality of your password and account.
          </p>

          <h2>2. Community Guidelines</h2>
          <p>
            Users agree to use the platform in a respectful manner. You agree not to post or transmit any content that is unlawful, harmful, threatening, abusive, harassing, defamatory, vulgar, or otherwise objectionable. The society management committee reserves the right to remove any content that violates these guidelines.
          </p>

          <h2>3. Payments and Maintenance</h2>
          <p>
            Any maintenance dues or event fees paid through the portal are subject to the society's financial policies. Late payments may attract penalties as decided by the AGM. All payment disputes should be addressed directly to the society treasurer.
          </p>

          <h2>4. Facilities Booking</h2>
          <p>
            Booking of society facilities (Club House, Community Hall, etc.) through the portal is subject to availability and the specific rules governing those spaces. Users are responsible for any damages caused during their booking period.
          </p>

          <h2>5. Modifications to Terms</h2>
          <p>
            Sanskriti Shubh Aangan reserves the right to modify these Terms and Conditions at any time. We will do our best to notify you of any significant changes, but it is your responsibility to review these terms periodically.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Terms;
